import { connect } from 'react-redux';
import { isAwaitingFiltration } from 'src/routes/SeoApp/domain/state/filters/status_selectors';
import { getHotelsCount } from 'src/routes/SeoApp/domain/state/hotels/selectors';
import { applyFiltersAction } from 'src/routes/SeoApp/domain/state/mobile/actions';
import { FiltersApplyMobile } from './FiltersApply';

const mapStateToProps = (state) => ({
  hotelsCount: getHotelsCount(state),
  fetching: isAwaitingFiltration(state),
});

const mapDispatchToProps = {
  applyFilters: applyFiltersAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersApplyMobile);
